import { Box, Flex, Button } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { UpdateChangesContent } from "components/servicos-components/user-licences/modal-update-changes/update-changes-content";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { RoutePermissionFunction, useRouter } from "router-manager/parts";

function MudancasUpdatePage() {
  const router = useRouter();
  return (
    <GetLayout
      title="Mudanças na cobrança e cashback"
      pageTitleProps={{
        onClick: () => router.push("/")
      }}
    >
      <Box p={6} maxW="1200px" mx="auto">
        <UpdateChangesContent />

        <Flex justify="flex-end" gap={4} align="center">
          <Button
            variant="outline"
            leftIcon={<ArrowBackIcon />}
            onClick={() => router.push("/")}
          >
            Voltar
          </Button>
          <Button
            px={8}
            onClick={() => {
              router.push("/");
              window.localStorage.setItem("avisos-update-visible", "false");
            }}
          >
            Entendi
          </Button>
        </Flex>
      </Box>
    </GetLayout>
  );
}

export default MudancasUpdatePage;

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => !!user?.isLogged);
};
